import { browserCheck } from '@ta-interaktiv/browsercheck'

export const isMobile = browserCheck.isMobile
export const errorExcuses: Record<
  valueTypeType,
  Record<dataTypeType, Record<popTypeType, string>>
> = {
  new: {
    cases: {
      abs:
        'weil durchschnittlich 10 Neuinfektionen noch nicht überschritten wurden.',
      pop:
        'weil 0.1 durchschnittliche Neuinfektionen pro 1 Mio. Einwohner noch nicht überschritten wurden.'
    },
    death: {
      abs:
        'weil durchschnittlich 3 Todesfälle noch nicht überschritten wurden.',
      pop:
        'weil 0.1 durchschnittliche Todesfälle pro 1 Mio. Einwohner noch nicht überschritten wurden.'
    }
  },
  cum: {
    cases: {
      abs: 'weil noch keine 100 bestätigten Fälle erreicht wurden.',
      pop:
        'weil 3 bestätigte Fälle pro 1 Mio. Einwohner noch nicht überschritten wurden.'
    },
    death: {
      abs: 'weil noch keine 100 Todesfälle erreicht wurden.',
      pop:
        'weil 3 Todesfälle pro 1 Mio. Einwohner noch nicht überschritten wurden.'
    }
  }
}

export const drawProp: drawPropType = {
  new: {
    cases: { abs: 'newCases', pop: 'newCasesPop' },
    death: { abs: 'newDeath', pop: 'newDeathPop' }
  },
  cum: {
    cases: { abs: 'cumCases', pop: 'cumCasesPop' },
    death: { abs: 'cumDeath', pop: 'cumDeathPop' }
  }
}

export const bigChartTitle: Record<
  valueTypeType,
  Record<dataTypeType, Record<popTypeType, { t: string; s: string; x: string }>>
> = {
  new: {
    cases: {
      abs: {
        t: 'Tägliche bestätigte Neuinfektionen',
        s: 'Ø über 7 Tage der täglichen Neuinfektionen',
        x:
          'Anzahl Tage seit dem erstmaligen Überschreiten von durchschnittlich 10 Neuinfektionen'
      },
      pop: {
        t: 'Tägliche bestätigte Neuinfektionen',
        s: 'Ø über 7 Tage der täglichen Neuinfektionen pro 1 Mio. Einwohner',
        x:
          'Anzahl der Tage seit dem erstmaligen Überschreiten von 0.1 durchschnittlichen Neuinfektionen pro 1 Mio. Einwohner'
      }
    },
    death: {
      abs: {
        t: 'Tägliche Todesfälle in Verbindung mit Covid-19',
        s: 'Ø über 7 Tage der täglichen Todesfälle ',
        x:
          'Anzahl Tage seit dem erstmaligen Überschreiten von durchschnittlich 3 Todesfällen'
      },
      pop: {
        t: 'Tägliche Todesfälle in Verbindung mit Covid-19',
        s: 'Ø über 7 Tage der täglichen Todesfälle pro 1 Mio. Einwohner',
        x:
          'Anzahl Tage seit dem erstmaligen Überschreiten von 0.1 durchschnittlichen Todesfällen pro 1 Mio. Einwohner'
      }
    }
  },
  cum: {
    cases: {
      abs: {
        t: 'Gesamtzahl der bestätigten Infektionen',
        s: 'Kumulierte Infektionen',
        x:
          'Anzahl Tage seit dem erstmaligen Überschreiten von 100 bestätigten Infektionen'
      },
      pop: {
        t: 'Gesamtzahl der bestätigten Infektionen',
        s: 'Kumulierte Infektionen pro 1 Mio. Einwohner',
        x:
          'Anzahl Tage seit dem erstmaligen Überschreiten von 3 bestätigten Infektionen pro 1 Mio. Einwohner'
      }
    },

    death: {
      abs: {
        t: 'Gesamtzahl der Todesfälle in Verbindung mit Covid-19',
        s: 'Kumulierte Todesfälle',
        x: 'Anzahl Tage seit dem erstmaligen Überschreiten von 100 Todesfällen'
      },
      pop: {
        t: 'Gesamtzahl der Todesfälle in Verbindung mit Covid-19',
        s: 'Kumulierte Todesfälle pro 1 Mio. Einwohner',
        x:
          'Anzahl Tage seit dem erstmaligen Überschreiten von 3 Todesfällen pro 1 Mio. Einwohner'
      }
    }
  }
}

export const xDomain = {
  cum: {
    cases: { abs: [0, 180], pop: [0, 180] },
    death: { abs: [0, 180], pop: [0, 150] }
  },
  new: {
    cases: { abs: [0, 180], pop: [0, 150] },
    death: { abs: [0, 150], pop: [0, 150] }
  }
}
export const xTicks = {
  cum: {
    cases: { abs: [0, 60, 120, 180], pop: [0, 60, 120, 180] }, //
    death: { abs: [0, 60, 120, 180], pop: [0, 30, 60, 90, 120, 150] }
  },
  new: {
    cases: { abs: [0, 60, 120, 180], pop: [0, 30, 60, 90, 120, 150] },
    death: { abs: [0, 30, 60, 90, 120, 150], pop: [0, 30, 60, 90, 120, 150] }
  }
}

export const yDomain = {
  cum: {
    cases: { abs: [100, 5000000], pop: [3, 50000] },
    death: { abs: [100, 200000], pop: [3, 5000] }
  },
  new: {
    cases: { abs: [0.1, 100000], pop: [0.01, 1000] },
    death: { abs: [0.1, 3000], pop: [0.01, 80] }
  }
}
export const yTicks = {
  cum: {
    cases: {
      abs: [100, 1000, 10000, 100000, 1000000, 5000000],
      pop: [3, 50, 500, 5000, 50000]
    },
    death: { abs: [100, 1000, 10000, 200000], pop: [3, 100, 1000, 5000] }
  },
  new: {
    cases: {
      abs: [0.1, 1, 10, 100, 1000, 10000, 100000],
      pop: [0.01, 1, 10, 100, 1000]
    },
    death: {
      abs: [0.1, 1, 10, 100, 1000, 3000],
      pop: [0.01, 1, 10, 20, 40, 80]
    }
  }
}
